var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{class:_vm.className,attrs:{"small":"","color":"success","loading":_setup.isLoading,"disabled":_setup.isLoading},on:{"click":_setup.downloadToExcel}},[_vm._v(" 엑셀 다운로드 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }